import { toast } from "react-toastify";

// Same-origin by default (the platform serves this SPA at /admin). Cookie auth —
// the admin JWT cookie is sent automatically via credentials:"include".
const BASE = process.env.REACT_APP_GENERATOR_API_URL || "";

async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  let body = options.body;
  if (body !== undefined && body !== null && !(body instanceof FormData) && typeof body !== "string") {
    headers.set("Content-Type", "application/json");
    body = JSON.stringify(body);
  }
  const res = await fetch(BASE + path, { credentials: "include", ...options, headers, body });

  if (!res.ok) {
    let detail = res.statusText;
    try {
      detail = (await res.json()).detail || detail;
    } catch {
      /* non-JSON error body */
    }
    if (!options.silent && res.status !== 401) toast.error(detail);
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  if (options.blob) return res.blob(); // binary responses (e.g. generated images)
  const ct = res.headers.get("content-type") || "";
  return ct.includes("json") ? res.json() : res.text();
}

const api = {
  get: (path, opts) => request(path, { method: "GET", ...opts }),
  post: (path, body, opts) => request(path, { method: "POST", body, ...opts }),
  postBlob: (path, body, opts) => request(path, { method: "POST", body, ...opts, blob: true }),
  patch: (path, body, opts) => request(path, { method: "PATCH", body, ...opts }),
  del: (path, opts) => request(path, { method: "DELETE", ...opts }),
};

export default api;
